// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workflow-editor-validation-notification-header {
    position: relative;
}

.workflow-editor-validation-notification-details-toggle {
    cursor: pointer;
    position: absolute;
    right: -5px;
    top: 0;
}

.workflow-editor-validation-notification-details {
    margin-top: 10px;
    margin-left: 20px;
    color: #555555;
}

.workflow-editor-validation-notification-message {
    padding-right: 17px;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/components/node-validation-panel/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".workflow-editor-validation-notification-header {\n    position: relative;\n}\n\n.workflow-editor-validation-notification-details-toggle {\n    cursor: pointer;\n    position: absolute;\n    right: -5px;\n    top: 0;\n}\n\n.workflow-editor-validation-notification-details {\n    margin-top: 10px;\n    margin-left: 20px;\n    color: #555555;\n}\n\n.workflow-editor-validation-notification-message {\n    padding-right: 17px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
